import React, { Fragment, useEffect, useRef, useState } from "react";
import { bool, string } from "prop-types";
import { useDispatch, connect } from "react-redux";
import { selectors as onboardingSelectors, actions as onboardingActions } from "reducers/onboarding";
import Notification from "pages/_components/Notification";
import Image from "pages/_components/Image";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import CustomText from "pages/_components/CustomText/CustomText";
import { Col } from "react-bootstrap";
import * as i18nUtils from "util/i18n";
import gaEventTracker, { events } from "util/gaEventTracker";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import Checkbox from "pages/_components/Checkbox";
import CustomData from "pages/_components/CustomData/CustomData";
import { actions as actionSoftToken } from "reducers/softToken";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import { push } from "connected-react-router";
import {
    defaultTextCheckboxTermsAndConditions,
    getValidationSchemaTermsAndConditions,
    TERMS_AND_CONDITIONS_CATEGORY_PF,
} from "../../../util/onboarding";

const FORM_ID = "onboarding.vu";

const checkboxContainerStyle = {
    display: "flex",
    flexDirection: "row",
    verticalAlign: "middle",
};
const checkboxLabelStyle = {
    paddingLeft: "0%",
    paddingTop: "0%",
    textAlign: "justify",
    textJustify: "interWord",
};
const StepUserFinish = ({
    isMobile,
    onboardingWithInvitation,
    exchangeToken,
    acceptTermsAndConditionsPF,
    acceptTokenTermAndConditions,
}) => {
    const dispatch = useDispatch();
    const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(acceptTermsAndConditionsPF);
    const [acceptToken, setAcceptToken] = useState(acceptTokenTermAndConditions);

    const formRef = useRef(null);

    useEffect(() => {
        if (onboardingWithInvitation) {
            gaEventTracker.triggerEvent(events.firmRegistry6);
        }
        return () => {
            dispatch(onboardingActions.restartOnboardingStore());
        };
    }, [dispatch]);

    const onChangeCheckboxTermsAndConditions = () => {
        setAcceptTermsAndConditions(!acceptTermsAndConditions);
        dispatch(onboardingActions.acceptTermsAndConditionsPF(!acceptTermsAndConditions));
    };

    const onChangeCheckboxToken = () => {
        setAcceptToken(!acceptToken);
        dispatch(onboardingActions.acceptTokenTermsAndConditions(!acceptToken));
    };

    const handleOnclickTokenTermsAndConditions = () => {
        dispatch(push("/onboarding/stepUserFinish/tokenTermsAndConditions"));
    };

    const handleOnclickTermsAndConditions = () => {
        dispatch(push("/onboarding/stepUserFinish/termsAndConditions"));
    };

    const handleAcceptTermsAndConditions = () => {
        dispatch(
            onboardingActions.acceptTermsAndConditionsFinishStepPF(TERMS_AND_CONDITIONS_CATEGORY_PF, exchangeToken),
        );
    };

    const initialValuesForm = {
        terms: acceptTokenTermAndConditions,
        termsConditions: acceptTermsAndConditionsPF,
    };

    const formikProps = {
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: () => Yup.lazy(() => getValidationSchemaTermsAndConditions()),
        onSubmit: (valuesForm) => {
            const isCheckedToken = valuesForm?.terms;
            if (isCheckedToken) {
                dispatch(actionSoftToken.getDeviceSee(exchangeToken));
            }
            handleAcceptTermsAndConditions();
        },
    };
    return (
        <Fragment>
            <Notification scopeToShow="login" />
            {isMobile && (
                <Head
                    title="onboarding.noUser.title"
                    // onBack={isMobile && onHeaderBack}
                    hideNavbarInMobile
                />
            )}
            <MainContainer>
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText text={i18nUtils.get("", "¡Felicitaciones! Terminaste el registro")} />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image
                        src={
                            onboardingWithInvitation
                                ? "figma/illustrations/onboarding9.svg"
                                : "figma/illustrations/onboarding3.svg"
                        }
                        className="svg-image logo"
                    />
                </div>
                <div className="box box-border-soft">
                    <CustomText
                        text={i18nUtils.get(
                            "",
                            "¡Ahora podés ingresar a BiBank y comenzar con el proceso de alta de tu empresa!",
                        )}
                    />
                </div>
                <div className="container--alert" role="alert">
                    <div className="alert alert-info">
                        <CustomData
                            icon="information_fill.svg"
                            titleText="Te recordamos que podrás utilizar tu Token para confirmar tus operaciones."
                            keepSpaceIfNoValue={false}
                        />
                    </div>
                </div>
                <Formik {...formikProps} ref={formRef} initialValues={initialValuesForm}>
                    {() => (
                        <Form className="above-the-fold" ref={formRef}>
                            <div className="form-actions" style={{ paddingTop: "0" }}>
                                <div style={checkboxContainerStyle}>
                                    <Field
                                        component={Checkbox}
                                        idForm={FORM_ID}
                                        name="termsConditions"
                                        hideLabel
                                        onChange={() => onChangeCheckboxTermsAndConditions()}
                                    />
                                    <Button
                                        style={checkboxLabelStyle}
                                        className="btn-link"
                                        block={false}
                                        onClick={() => handleOnclickTermsAndConditions()}>
                                        <CustomText
                                            text={i18nUtils.get(
                                                "onboarding.vu.terms.and.conditions.label",
                                                defaultTextCheckboxTermsAndConditions,
                                            )}
                                        />
                                    </Button>
                                </div>
                                <div style={checkboxContainerStyle}>
                                    <Field
                                        component={Checkbox}
                                        idForm={FORM_ID}
                                        name="terms"
                                        hideLabel
                                        onChange={() => onChangeCheckboxToken()}
                                    />
                                    <Button
                                        style={checkboxLabelStyle}
                                        className="btn-link"
                                        block={false}
                                        onClick={() => handleOnclickTokenTermsAndConditions()}>
                                        <CustomText text={i18nUtils.get("", `Acepto la activación de mi Token.`)} />
                                    </Button>
                                </div>
                                <Button
                                    bsStyle="primary"
                                    defaultLabelText="Finalizar"
                                    type="submit"
                                    block
                                    disabled={!(acceptTermsAndConditions && acceptToken)}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </Fragment>
    );
};

StepUserFinish.propTypes = {
    isMobile: bool.isRequired,
    onboardingWithInvitation: bool.isRequired,
    exchangeToken: string.isRequired,
    acceptTermsAndConditionsPF: bool.isRequired,
    acceptTokenTermAndConditions: bool.isRequired,
};

const mapStateToProps = (state) => ({
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    userData: onboardingSelectors.getDataUser(state),
    acceptTermsAndConditionsPF: onboardingSelectors.getAcceptTermConditionsPF(state),
    acceptTokenTermAndConditions: onboardingSelectors.getAcceptTokenTermConditions(state),
});

export default connect(mapStateToProps)(StepUserFinish);
